import React from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, Clock, Trophy } from "lucide-react";

export function StatCard({ label, value, icon: Icon }) {
  return (
    <div className="bg-white rounded-xl border border-neutral-200 p-6">
      <div className="flex items-center justify-between">
        <div className="text-xs uppercase tracking-[0.18em] text-neutral-500">{label}</div>
        <Icon className="w-4 h-4 text-forest/60" />
      </div>
      <div className="font-display text-3xl text-forest mt-2">{value}</div>
    </div>
  );
}

/**
 * Item 4 (2026-07): "My impact" — the remaining stat tiles as ONE compact row
 * (the old "Current tier" tile merged into the page header) + View badges link.
 */
export function MyImpactRow({ stats }) {
  return (
    <div className="mt-10" data-testid="my-impact-row">
      <div className="flex items-center justify-between flex-wrap gap-2">
        <h2 className="font-display text-2xl text-forest tracking-tight">My impact</h2>
        <Link data-testid="view-badges-link" to="/recognition?tab=badges" className="text-sm text-forest hover:underline font-medium">
          View badges →
        </Link>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mt-4">
        <StatCard label="Approved hours" value={stats.total_hours} icon={Clock} />
        <StatCard label="Logs submitted" value={stats.logs_count} icon={CheckCircle2} />
        <StatCard label="Organisations" value={stats.orgs_count} icon={Trophy} />
      </div>
    </div>
  );
}
